import { render, staticRenderFns } from "./ContentNewGuide.vue?vue&type=template&id=5a60012f&scoped=true"
import script from "./ContentNewGuide.vue?vue&type=script&lang=js"
export * from "./ContentNewGuide.vue?vue&type=script&lang=js"
import style0 from "./ContentNewGuide.vue?vue&type=style&index=0&id=5a60012f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60012f",
  null
  
)

export default component.exports